(function ($) {
    var $grid = $('.template-collection .card-grid');

    $grid.masonry({
        gutter: 20
    });

    $grid.children('div').on('animate_element', function () {
        $grid.masonry();
    });

    setTimeout(function () {
        $grid.masonry();
    }, 1200);

    $( document ).ready(function() {
        $grid.masonry();
    });

})(jQuery);



(function ($) {

    var ga = {
            skipLink: ".skip-link",
            navigation: ".navigation",
            navAnimateElements: ".navigation__entrance-animation",
            cartBubble: ".site-header__cart-bubble",
            siteHeader: ".site-header",
            siteHeaderWrapper: ".site-header__wrapper",
            siteHeaderLogo: ".site-header__logo",
            siteHeaderCart: ".site-header__cart",
            navigationButton: ".site-header__navigation",
            navigationExpandSublinks: ".navigation__expand-sublinks",
            navigationSublinks: ".navigation__sublinks",
            navigationHasSublinks: ".navigation__has-sublinks",
            announcementBar: ".announcement-bar",
            announcementBarClose: ".announcement-bar__close"
        },
        va = {
            themeEditor: "theme-editor",
            headerFixed: "site-header--fixed",
            headerHomepage: "site-header--homepage",
            cartBubbleVisible: "site-header__cart-bubble--visible",
            bubblePulse: "bubble-pulse",
            drawerActive: "drawer--active",
            navigationOpen: "navigation-open",
            navigationOpenEditor: "navigation-open--editor",
            navigationTransitioning: "navigation--is-transitioning",
            navigationHasSublinksCollapsed: "navigation__has-sublinks--collapsed",
            navigationEntranceActive: "navigation__entrance-animation--active",
            siteHeaderWrapperTransitioning: "site-header__wrapper--transitioning",
            announcementBarVisible: "announcement-bar--visible"
        };

    function _toggleNavigationSublinks() {
        var t = $(this),
            e = t.parent();

        if ($(window).width() < 750)
            return;

        if (t.hasClass('navigation__has-sublinks--collapsed')) {

            t.toggleClass(va.navigationHasSublinksCollapsed);
            t.siblings(ga.navigationHasSublinks).addClass(va.navigationHasSublinksCollapsed).children(ga.navigationExpandSublinks);

            let left = t.find('.visually-hidden').offset().left-31;
            const paddingLeft = window.innerWidth < 1290 ? 20 : 0; //is the padding left of the css class .page-width

            if (t.hasClass('align-menu-left')) {                
                left = t.offset().left - paddingLeft;
            }
            
            if (t.hasClass('align-menu-right')) { 
                const alignLeft = window.innerWidth > 1450
                left = alignLeft ? 
                    t.offset().left - paddingLeft : 
                    t.offset().left - t.find('ul.navigation__sublinks').width() + t.width() + 40 - paddingLeft;
            }
            
            t.find('ul.navigation__sublinks').css('left', left);
        }

    }

    function _hiveNavigations() {
        if ($(window).width() < 750)
            return;

        var t = $(this),
            e = t.parent();

        if (t.is(':not(.navigation__has-sublinks--collapsed)')) {
            t.addClass(va.navigationHasSublinksCollapsed).children(ga.navigationExpandSublinks);
        }
    }

    $(document).ready(function () {
        $('.navigation .navigation__has-sublinks').hover(
            _toggleNavigationSublinks,
            _hiveNavigations
        );

        $('.navigation .navigation__has-sublinks').click(function () {
            var t = $(this),
                e = t.parent();

            if (t.is(':not(.navigation__has-sublinks--collapsed)')) {
                if($(window).width()<769){//mobile
                    t.removeClass('menu-active-ct');

                    // t.find('.plus-submenu-sign-ct').css('transform', 'unset');
                    // t.find('.plus-submenu-sign-ct').css('right', '85px');
                }
            }else{
                if($(window).width()<769){//mobile
                    $('.navigation .navigation__has-sublinks').removeClass('menu-active-ct');

                    t.addClass('menu-active-ct');

                    var notClass_el = $('.navigation .navigation__has-sublinks').not('.menu-active-ct');

                    notClass_el.addClass('navigation__has-sublinks--collapsed');
                    // notClass_el.find('.plus-submenu-sign-ct').css('transform', 'unset');
                    // notClass_el.find('.plus-submenu-sign-ct').css('right', '85px');

                    // t.find('.plus-submenu-sign-ct').css('transform', 'rotate(45deg)');
                    // t.find('.plus-submenu-sign-ct').css('right', '83px');
                }
            }

            if ($(window).width() >= 750)
                return;

            // if (t.hasClass('navigation__has-sublinks--collapsed')) {
            //     t.siblings(ga.navigationHasSublinks).addClass(va.navigationHasSublinksCollapsed).children(ga.navigationExpandSublinks);
            // }

            t.toggleClass(va.navigationHasSublinksCollapsed);
        });

        $('.site-header__search').on('click', function (e) {

            e.preventDefault();

            if (window.matchMedia("(max-width: 750px)").matches) {
                $('.navigation-search-inline').removeClass('show-search');
                window.location.href = '/search';
                /* The viewport is less than, or equal to, 700 pixels wide */
            } else {
                $('.navigation-search-inline').toggleClass('show-search');
                /* The viewport is greater than 700 pixels wide */
            }

        });

        // For menu
        menuRestruct();


        // For scroll
        stickyCalculate();
    });

    $(window).on('scroll', function () {
        stickyCalculate();
    });


    var sticky = 160;
    let sticky_mobile = 76;

    function stickyCalculate() {
        if ((window.pageYOffset >= sticky && $(window).width() >= 750) || (window.pageYOffset >= sticky_mobile && $(window).width() < 750)){
            $('body').addClass("sticky")
        } else {
            $('body').removeClass("sticky")
        }

        // var sticky = new Waypoint.Sticky({
        //     element: $('#shopify-section-header')[0]
        // })

        // var waypoints = $('#shopify-section-header').waypoint('sticky');
    }

    function menuRestruct(){
        $('.navigation__sublinks-container').each(function () {
            let that = $(this);
            if (that.find('.menuitem-column').length > 0) {
                that.find('.navigation__sublinks').addClass('navigation__sublinks--column');
            } else if (that.find('.menuitem-row').length > 0) {
                that.find('.navigation__sublinks').addClass('navigation__sublinks--row');
            }
        })
    }

    if($(window).width()<769){//mobile
        $('.site-header .navigation__has-sublinks').prepend('<div class="plus-submenu-sign-ct"><svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="svg-inline--fa fa-plus fa-w-12 fa-5x"><path fill="currentColor" d="M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z" class=""></path></svg></div>');
    }

})(jQuery);
var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) { return; }
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;
    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;
    // Build request URL
    var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
            var container = document.createElement("div");
            container.innerHTML = request.response;
            productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
        }
    };
    request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
        loadProductRecommendationsIntoSection();
    }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();
var currentProduct = {},
    newSKU = '';

(function ($) {
    $('.size-chart-open-popup').magnificPopup({
        type: 'inline',
        midClick: false,
        showCloseBtn: true,
        closeBtnInside: true
    });

    $(document).ready(function () {
        $('label[for=Size]').hide();
        $('#Size').change(function (e) {
            if($(this).val() != ''){
                $('label[for=Size]').show();
            }else{
                $('label[for=Size]').hide();
            }
        });

        if ($('label[for=Size]').length > 0){
            $('.product__add-to-cart-button').on('click', add_to_cart_click);
            $('.product__add-to-cart-button .primary-text').html(theme.strings.req_infomation);
        }
    });
})(jQuery);

function add_to_cart_click(e){
    e.preventDefault();
    jQuery('.contact-popup-link').trigger('click');
}
jQuery(document).ready(function( $ ) {

        var swiper = new Swiper('.swiper-container', {
            lazy: true,
            autoHeight: true, //enable auto height
            spaceBetween: 30,
            effect: 'fade',
            autoplay: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            loop: true
        });


});